import { render, staticRenderFns } from "./EduListYjj.vue?vue&type=template&id=bc4ca42c&scoped=true&"
import script from "./EduListYjj.vue?vue&type=script&lang=js&"
export * from "./EduListYjj.vue?vue&type=script&lang=js&"
import style0 from "./EduListYjj.vue?vue&type=style&index=0&id=bc4ca42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ca42c",
  null
  
)

export default component.exports